<template>
  <section>
    <div class="section">
      <div class="container">
        <div class="columns is-centered">
          <div class="column is-6">
            <div class="is-inline-block px-3">
              <figure class="image content is-32x32">
                <img src="favicon.ico" alt="" />
              </figure>
            </div>
            <h1 class="title is-inline-block">News from Tanukos</h1>
            <div class="box">
              <h1 class="has-text-dark-orange has-text-weight-semibold is-size-4">
                Release - v0.0.0
              </h1>
              <p class="has-text-gray is-size-6">31th of December 2020</p>

              <p class="py-2 has-text-justified">
                Welcome to the Alpha version of Costuto!<br />
                This version is the first release ever so it might still contain multiple
                bugs and you will probably encouter unexpected behavior. <br />
                We count on your support to take note of those issues, the functionalities
                that are not intuitive to you and any question you might have so that we
                can add them to the FAQ and solve them for the Beta release.<br />
                Let's make Costuto a great place all together!<br />
                Tanukos.
              </p>

              <div class="content">
                <span class="has-text-weight-semibold is-size-5">New features</span>
                <ul>
                  <li>First version of Costuto</li>
                </ul>
                <span class="has-text-weight-semibold is-size-5">Fixes</span>
                <ul>
                  <li>First version of Costuto</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped></style>
